import React, { useState, useCallback } from 'react';
import { Button } from '@ontruck/orc';
import Tag from 'components/Tag';
import api from 'api';
import { useDispatch } from 'react-redux';
import { actions as uiActions } from 'state/ui';

const UserCard = ({ t, className, isFirst, user, onClick }) => {
  const [resendActionUsed, setResendActionUsed] = useState(false);
  const dispatch = useDispatch();

  const handleResendInvitation = useCallback(
    (e) => {
      e.stopPropagation();
      try {
        api.resendUserInvitation({ userId: user.id });
        setResendActionUsed(true);
        dispatch(
          uiActions.setFeedback({
            feedback: 'InviteUserModal:send_action.success',
            params: {
              email: user.username,
            },
          })
        );
      } catch (e) {
        console.error(e);
        dispatch(
          uiActions.setFeedback({
            feedback: 'InviteUserModal:send_action.error',
            success: false,
          })
        );
      } finally {
        setTimeout(() => {
          dispatch(
            uiActions.setFeedback({
              feedback: null,
            })
          );
        }, 4000);
      }
    },
    [dispatch, user]
  );

  if (!user) return null;
  return (
    <div onClick={onClick} className={`${className} ${isFirst ? 'first' : ''}`}>
      <div className="info">
        <p className="name">
          {user.first_name} {user.last_name}
        </p>
        <p className="email">{user.email}</p>
        <p className="phone">{user.phone || t('no_phone')}</p>
      </div>
      <div className="actions">
        {!user.is_active && (
          <>
            <Tag className="confirmed-tag">{t('not_confirmed')}</Tag>
            <span className="hidden-action margin-right">
              <Button
                onClick={handleResendInvitation}
                text={t('resend')}
                skin="secondary"
                disabled={resendActionUsed}
              />
            </span>
          </>
        )}
        <span className="hidden-action edit-button">
          <Button text={t('edit')} skin="secondary" onClick={onClick} />
        </span>
      </div>
    </div>
  );
};
export default UserCard;
